import React from 'react';
import { Text, View } from 'react-native';
import { styles } from '../../utils/style';
import Flex from '../Flex';
export function Space(props) {
    const { direction = 'horizontal', children, gap = 0, style, activeOpacity = 0.6, itemStyle, bs, onPress, } = props || {};
    const childs = React.Children.toArray(children).filter((v) => v !== null);
    const childNum = childs.length;
    return (React.createElement(Flex, { onPress: onPress, activeOpacity: activeOpacity, flex: direction === 'horizontal' ? 'flexRow' : 'flexCol', style: style, bs: bs }, childs.map((child, index) => {
        const childStyle = direction === 'horizontal'
            ? styles({
                marginRight: index < childNum - 1 && childNum > 1
                    ? gap
                    : 0,
                alignSelf: 'center',
            })
            : styles({
                marginBottom: index < childNum - 1 ? gap : 0,
            });
        if (['string', 'number'].includes(typeof child)) {
            return (React.createElement(Text, { key: 'space_key_' + Math.random(), style: childStyle }, child));
        }
        return (React.createElement(View, { key: 'space_key_' + Math.random(), style: [childStyle, styles(itemStyle)] }, child));
    })));
}
export default Space;
